import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';

@Component({
  selector: 'reporting',
  templateUrl: './reporting.component.html',
  styles: ['.printButton { margin-bottom: 5px;}'],
  providers: []
})

export class ReportingComponent {

  constructor(private transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    private router: Router,
    public permissions: PermissionsService) {
  }

  tenantConfig = this.transferHttp.tenantConfig;
  tenantUsesPsc = this.tenantConfig.hr.tenantUsesPsc;

  //***************************
  // Variables
  //***************************

  //DropDown Values
  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);

  defaultEmployee: { fullName: string, employeeNumber: string } = { fullName: '---select---', employeeNumber: null };

  employee: number;

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //***************************
  // Functions
  //***************************


  public printActiveAndEOAEmpCounts() {
    this.router.navigate([`reporting/HR_ActiveAndEOAEmpCounts/trdp/`]);
  }

  public printActiveAndEOAEmpList() {
    this.router.navigate([`reporting/HR_ActiveAndEOAEmpList/trdp/`]);
  }

  public printActiveAndEOAShareholderList() {
    this.router.navigate([`reporting/HR_ActiveAndEOAShareholderList/trdp/`]);
  }

  public printActiveAndEOAVeteranList() {
    this.router.navigate([`reporting/HR_ActiveAndEOAVeteranList/trdp/`]);
  }

  public printActiveAndEOASpecialtyList() {
    this.router.navigate([`reporting/HR_ActiveAndEOASpecialtyList/trdp/`]);
  }

  public printClearanceStatus() {
    this.router.navigate([`reporting/HR_ClearanceStatus/trdp/`]);
  }

  public printSeniorityList() {
    this.router.navigate([`reporting/HR_Seniority_List/trdp/`]);
  }

  public printDLStatus() {
    this.router.navigate([`reporting/HR_DLStatus/trdp/`]);
  }

  public printEmpAddressesAndContact() {
    this.router.navigate([`reporting/HR_Employee_AddressesAndContact/trdp/`]);
  }

  public printCACStatus() {
    this.router.navigate([`reporting/HR_CACStatus/trdp/`]);
  }

  public printOfficePhoneListing() {
    this.router.navigate([`reporting/HR_Emp_OfficePhoneNumbers/trdp/`]);
  }

  public printEmpStatusChange() {
    this.router.navigate([`reporting/HR_EmpStatusChange/trdp/`]);
  }

  public printProbationReport() {
    this.router.navigate([`reporting/HR_Probation_Info/trdp/`]);
  }

  public printYearsOfService() {
    this.router.navigate([`reporting/YearsOfService/trdp/`]);
  }

  public printEmployeeAgeStatistics() {
    this.router.navigate([`reporting/EmployeeAgeStatistics/trdp/`]);
  }

  public printEmpHours() {
    this.router.navigate([`reporting/EmpHours/trdp/`]);
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }
}
